// extracted by mini-css-extract-plugin
export default {"card":"style_card__fslHz","card__imgBg":"style_card__imgBg__8x0j1"};